import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const RegistrationPrompt = ({ isLoading }) => {
  const navigate = useNavigate();

  const handleRegisterClick = () => {
    navigate('/register');
  };

  return (
    <div className="mt-8 pt-6 border-t border-border">
      <div className="text-center">
        <div className="bg-muted/30 rounded-lg p-6">
          <div className="flex justify-center mb-4">
            <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
              <Icon name="UserPlus" size={24} className="text-primary" />
            </div>
          </div>
          
          <h3 className="text-lg font-semibold text-foreground mb-2">
            New to HireBroker?
          </h3>
          
          <p className="text-sm text-muted-foreground mb-4">
            Join thousands of users finding their perfect properties. Create your free account to save favorites, get personalized recommendations, and access exclusive listings.
          </p>
          
          <div className="space-y-3">
            <Button
              variant="outline"
              size="default"
              onClick={handleRegisterClick}
              disabled={isLoading}
              iconName="ArrowRight"
              iconPosition="right"
              className="w-full sm:w-auto"
            >
              Create Free Account
            </Button>
            
            <div className="flex items-center justify-center space-x-4 text-xs text-muted-foreground">
              <div className="flex items-center space-x-1">
                <Icon name="Check" size={14} className="text-success" />
                <span>Free to join</span>
              </div>
              <div className="flex items-center space-x-1">
                <Icon name="Check" size={14} className="text-success" />
                <span>Save properties</span>
              </div>
              <div className="flex items-center space-x-1">
                <Icon name="Check" size={14} className="text-success" />
                <span>Get alerts</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationPrompt;
